// Fita.js — a faixa laranja que atravessa a página (18/10/2026).
//
// A mesma do site principal (insigne-landing-page, ui/Fita): duas faixas
// cruzadas, a laranja na frente inclinada para um lado e uma azul por trás
// inclinada para o outro, com as palavras na League Gothic andando devagar.
// As duas são mais largas que a tela (`-mx-[6%]`) para a inclinação não
// mostrar a ponta, e o contêiner corta o que sobra; sem isso a página
// ganharia rolagem lateral.
//
// É enfeite do começo ao fim: o leitor de tela pula a faixa inteira.
import React, { Fragment } from "react";
import Marca from "./Marca";

const PALAVRAS_PADRAO = ["Livros", "E-books", "Clube Insigne", "Autores", "Insigne"];

export default function Fita({ palavras = PALAVRAS_PADRAO, className = "" }) {
  const ultima = palavras[palavras.length - 1];
  const sequencia = (
    <>
      {[0, 1, 2].map((volta) => (
        <Fragment key={volta}>
          {palavras.map((p) => (
            <Fragment key={p}>
              <span className="font-display text-[1.6rem] uppercase leading-none tracking-[0.06em] sm:text-[1.9rem]">{p}</span>
              {p === ultima ? (
                <Marca className="h-6 sm:h-7" />
              ) : (
                <i className="bi bi-stars text-[1.05rem] sm:text-[1.25rem]" />
              )}
            </Fragment>
          ))}
        </Fragment>
      ))}
    </>
  );

  return (
    <div className={"relative overflow-hidden py-[1.75rem] sm:py-[2.25rem] " + className} aria-hidden="true">
      {/* A de trás: só a borda aparece, cruzando a da frente. */}
      <div className="absolute inset-x-0 top-1/2 -mx-[6%] h-10 -translate-y-1/2 rotate-[2.5deg] border-y-2 border-insigne-sombra bg-insigne-navy-mid sm:h-12" />

      <div className="fita relative -mx-[6%] -rotate-[2deg] overflow-hidden py-[0.5rem] sm:py-[0.625rem]">
        <div className="trilho-infinito" style={{ "--duracao": "45s" }}>
          {[0, 1].map((copia) => (
            <div key={copia} className="flex shrink-0 items-center gap-[1.25rem] pr-[1.25rem] sm:gap-[1.75rem] sm:pr-[1.75rem]">
              {sequencia}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
